import { z } from 'zod';

export const OpportunityPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  stage: z.string().min(1, 'Stage is required'),
  amount: z.number().positive(),
  expected_close_date: z.string().date().optional(),
  owner_user_id: z.string().uuid().optional(),
});

export type OpportunityProps = z.infer<typeof OpportunityPropsSchema>;
